import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"

import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap"
import moment from "moment"
import FullCalendar from "@fullcalendar/react" // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid" // a plugin!
import interactionPlugin from "@fullcalendar/interaction"
import BootstrapTheme from "@fullcalendar/bootstrap"
import AttendanceAction from "store/attendance-resource/actions"
import Select from "react-select"
import StaffAction from "store/staff-resource/actions"
import DatePicker from "react-flatpickr"
import LoadingComponent from "components/Loading/LoadingComponent"
import TableContainer from "components/tables/TableContainer"
import DetailAttendance from "../Detail"
import attendanceAPI from "helpers/attendance_backend_helper"

const TabAttendanceManagement = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [selectFilter, setSelectFilter] = React.useState("全社員日別")
  const [staffId, setStaffId] = React.useState("")
  const [staffForDetail, setStaffForDetail] = useState({})
  const [clickedDate, setClickedDate] = React.useState(null)
  const [date, setDate] = React.useState("")
  const [pageState, setPageState] = React.useState("calendar")
  const [all, setAll] = React.useState(false)

  React.useEffect(() => {
    dispatch(StaffAction.getList())
  }, [])

  const events = React.useMemo(() => {
    const current = []
    store.attendance.history.data.forEach((i, k) => {
      if (i.clockIn != "00:00") {
        current.push({
          date: moment(i.attendanceDate).toDate(),
          start: moment(`${i.attendanceDate} ${i.clockIn}`).unix() * 1000,
          className: "bg-warning",
        })
      }
      if (i.clockOut != "00:00") {
        current.push({
          date: moment(i.attendanceDate).toDate(),
          start: moment(`${i.attendanceDate} ${i.clockOut}`).unix() * 1000,
          className: "bg-success",
        })
      }
    })
    return current
  }, [store.attendance.history.loading])

  const columns = React.useMemo(
    () => [
      // {
      //   Header: "No",
      //   accessor: "staffId",
      //   defaultCanSort: false,
      // },
      {
        Header: "社員名",
        accessor: "staffName",
        defaultCanSort: false,
      },
      {
        Header: "出勤",
        accessor: "clockIn",
        defaultCanSort: false,
      },
      {
        Header: "退勤",
        accessor: "clockOut",
        defaultCanSort: false,
      },
      // {
      //   Header: "date",
      //   accessor: "attendanceDate",
      //   defaultCanSort: false,
      // },
      {
        Header: "",
        accessor: "format",
        defaultCanSort: false,
        Cell: ({ cell }) => {
          return (
            <Button
              // color="primary"
              className="button"
              onClick={() => {
                const _temp = []
                store.attendance.allHistory.data.forEach(i => {
                  if (i.staffId === cell.row.original.staffId) {
                    _temp.push(i)
                  }
                })
                setClickedDate(
                  moment(cell.row.original.attendanceDate).format("YYYY-MM-DD")
                )
                setStaffForDetail({
                  label: _temp[0].staffName,
                  value: cell.row.original.staffId,
                })
                setStaffId(cell.row.original.staffId)
                setPageState("detail")
                // history.push(`/attendance-management/${moment(cell.row.original.attendanceDate).format('YYYY-MM-DD')}/${cell.row.original.staffId}`)
              }}
            >
              編集
            </Button>
          )
        },
      },
    ],
    [store.attendance.allHistory.data]
  )

  const onDateSet = e => {
    if (staffId) {
      const date = moment(e.startStr).date()
      const dateMonth = moment(e.startStr).month()

      let year = moment(e.startStr).year()
      let month = moment(e.startStr).month()
      if (date > 1) {
        month = dateMonth + 2
      } else {
        month = dateMonth + 1
      }

      if (dateMonth == 11 && date > 1) {
        month = 1
        year = year + 1
      }
      dispatch(
        AttendanceAction.getMonthHistory({
          year,
          month,
          staffId,
        })
      )
    }
  }

  const downloadCSV = async () => {
    const _date = date
      ? new Date(date)
      : new Date(store.attendance.history.data[0].attendanceDate)
    const params = {
      year: _date.getFullYear(),
      month: _date.getMonth() + 1,
    }
    const payload = {
      staffId: staffId || 0,
      all: staffId ? all : true,
    }
    try {
      const { data } = await attendanceAPI.downloadCSV(params, payload)
      const link = document.createElement("a")
      link.href = URL.createObjectURL(
        new Blob([data], { type: "text/csv;charset=utf-8;" })
      )
      link.setAttribute(
        "download",
        "attendance-list" + new Date().getTime() + ".csv"
      )
      link.click()
    } catch (error) {
      console.log(error)
    }
  }

  const downloadCSVOutWork = async () => {
    try {
      const _date = date
        ? new Date(date)
        : new Date(store.attendance.history.data[0].attendanceDate)

      let params = {
        year: _date.getFullYear(),
        month: _date.getMonth() + 1,
      }

      if (staffId) {
        params = { ...params, staffId }
        const { data } = await attendanceAPI.downloadCSVOutWorkByStaff(params)
        const file = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        // process to auto download it
        const fileURL = URL.createObjectURL(file)
        const link = document.createElement("a")
        link.href = fileURL
        link.download = `attendance-list-out-work-staff.xlsx`
        link.click()
      } else {
        const { data } = await attendanceAPI.downloadCSVOutWork(params)
        const file = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        // process to auto download it
        const fileURL = URL.createObjectURL(file)
        const link = document.createElement("a")
        link.href = fileURL
        link.download = `attendance-list-out-work-staff.xlsx`
        link.click()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (selectFilter === "全社員日別") {
      setDate(new Date())
      dispatch(
        AttendanceAction.getAllHistoryDate(
          moment(new Date()).format("YYYY-MM-DD")
        )
      )
    }
  }, [selectFilter])

  return (
    <>
      <Card>
        <CardBody className="p-3">
          <Row>
            {pageState == "calendar" && (
              <>
                <Col lg="4">
                  <Select
                    options={[
                      {
                        value: "社員別",
                        label: "社員別",
                      },
                      {
                        value: "全社員日別",
                        label: "全社員日別",
                      },
                    ]}
                    onChange={e => {
                      setStaffId("")
                      setDate("")
                      setSelectFilter(e.value)
                    }}
                    value={{
                      value: selectFilter,
                      label: selectFilter,
                    }}
                    isClearable
                  />
                </Col>
                {selectFilter === "社員別" && (
                  <Col lg="4">
                    <Select
                      isLoading={store.staff.list}
                      options={store.staff.list.data.map(i => ({
                        value: i.id,
                        label: i.name,
                      }))}
                      value={{
                        value: staffId,
                        label: store.staff.list.data.find(i => i.id == staffId)
                          ?.name,
                      }}
                      defaultValue={{
                        value: staffId,
                        label: store.staff.list.data.find(i => i.id == staffId)
                          ?.name,
                      }}
                      onChange={e => {
                        setStaffId(e.value)
                        setStaffForDetail({
                          value: e.value,
                          label: e.label,
                        })
                        dispatch(
                          AttendanceAction.getMonthHistory({
                            year: moment().year(),
                            month: moment().month() + 1,
                            staffId: e.value,
                          })
                        )
                      }}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 10000 }),
                      }}
                    />
                  </Col>
                )}
                {selectFilter === "全社員日別" && (
                  <Col lg="4">
                    <DatePicker
                      className="form-control"
                      type="text"
                      onChange={date => {
                        setDate(date[0])
                        dispatch(
                          AttendanceAction.getAllHistoryDate(
                            moment(date[0]).format("YYYY-MM-DD")
                          )
                        )
                      }}
                      value={date}
                    />
                  </Col>
                )}
                {selectFilter && (staffId || date) && (
                  <Col lg="4" className="d-flex justify-content-end">
                    <Button
                      className="button me-2"
                      onClick={() => downloadCSVOutWork()}
                    >
                      作業別出力
                    </Button>
                    <div className="me-3 d-flex align-items-center">
                      {staffId && (
                        <InputGroup>
                          <Input
                            type="checkbox"
                            id="all"
                            onChange={({ target: { checked } }) =>
                              setAll(checked)
                            }
                            defaultChecked={!staffId}
                            disabled={!staffId}
                          />
                          <Label className="ms-2" htmlFor="all">
                            全て
                          </Label>
                        </InputGroup>
                      )}
                    </div>
                    <Button className="button" onClick={downloadCSV}>
                      出力
                    </Button>
                  </Col>
                )}
              </>
            )}
          </Row>

          {pageState != "calendar" ? (
            <DetailAttendance
              params={{ date: clickedDate, staffForDetail }}
              cancel={() => setPageState("calendar")}
            />
          ) : (
            <>
              {selectFilter == "全社員日別" && date ? (
                store.attendance.allHistory.loading ? (
                  <LoadingComponent />
                ) : (
                  <div className="mt-3">
                    <TableContainer
                      data={store.attendance.allHistory.data || []}
                      columns={columns}
                    />
                  </div>
                )
              ) : selectFilter == "社員別" && staffId ? (
                <>
                  {pageState == "calendar" && (
                    <Row className="my-3">
                      <Col>
                        <Badge color="warning" pill>
                          出勤
                        </Badge>
                        <Badge color="success" pill>
                          退勤
                        </Badge>
                      </Col>
                    </Row>
                  )}

                  <FullCalendar
                    plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    themeSystem="bootstrap"
                    headerToolbar={{
                      left: "",
                      center: "title",
                    }}
                    buttonText={{
                      today: "本日",
                    }}
                    events={events}
                    editable={true}
                    selectable={true}
                    droppable={false}
                    locale="ja"
                    eventClick={e => {
                      setClickedDate(e.event.startStr)
                      setPageState("detail")
                    }}
                    dateClick={e => {
                      setClickedDate(e.dateStr)
                      setPageState("detail")
                    }}
                    datesSet={onDateSet}
                  />
                </>
              ) : null}
            </>
          )}
        </CardBody>
      </Card>
    </>
  )
}

export default TabAttendanceManagement
